module.exports = __webpack_public_path__ + "media/images/icons/ic-email-e3f8b0a83d286ec671de8536ebf38925.svg";